import React from 'react';
import {
  useUpdateCustomizeItemWeightMutation,
} from 'api';
import useDebounce from 'hooks/useDebounce';
import {CustomizeItemContext} from '../CustomizeItemContext';

export default function WeightSlider() {
  const customizeItem = React.useContext(CustomizeItemContext);
  const [update] = useUpdateCustomizeItemWeightMutation({});
  const [weight, setWeight] = React.useState(customizeItem?.weight ?? 1);

  const debouncedValue = useDebounce<Number>(weight, 500);

  React.useEffect(() => {
    if (weight === null || !customizeItem?.id) {
      return;
    }
    update({
      variables: {
        id: customizeItem.id,
        weight: Number(weight),
      },
    });
  }, [debouncedValue]);

  return (
    <div className="w-40 max-w-sm flex items-center gap-2">
      <div className="flex items-center justify-center">
        <input
          type="range"
          className="cursor-pointer"
          value={weight}
          min={0}
          max={5}
          onChange={(e) => setWeight(Number(e.target.value))}
        />
      </div>
      <div className="text-base font-bold">
        {weight}
      </div>
    </div>
  );
}